import { cn } from "@/lib/utils";

export const RiskBadge = ({ risk, className }: { risk: "low" | "medium" | "high" | null | undefined; className?: string }) => {
  if (!risk) return <span className={cn("text-[10px] text-muted-foreground", className)}>— pending review</span>;
  const cls =
    risk === "high" ? "bg-destructive/15 text-destructive border-destructive/30" :
    risk === "medium" ? "bg-accent/20 text-accent-foreground border-accent/40" :
    "bg-success/15 text-success border-success/30";
  return (
    <span className={cn("inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase", cls, className)}>
      AI: {risk} risk
    </span>
  );
};
